<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>
      <v-list subheader two-line dense>
        <v-subheader>Invitados externos agregados</v-subheader>
        <template v-for="(item, index) in people.externs">
          <v-list-tile :key="index" avatar>
            <v-list-tile-action>
              <v-btn @click="removePerson(index)" icon>
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-avatar>
              <v-btn @click="editPerson(item, index)" icon>
                <v-icon>edit</v-icon>
              </v-btn>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title
                v-html="item.firstName + ' ' + item.lastName"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="item.email"
              ></v-list-tile-sub-title>
              <v-divider :key="index" :inset="true"></v-divider>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <p class="pl-3 mb-0 text--secondary" v-if="people.externs.length === 0">
        Aún no hay invitados externos
      </p>
    </v-flex>
    <v-flex xs12 md8 mt-4>
      <v-btn
        block
        class="gradiente"
        style="border-radius: 33px"
        dark
        @click="addPerson"
        >Añadir invitado</v-btn>
    </v-flex>
    <desition
      @desition="$event ? onDeletePerson() : ''"
      v-model="modals.confirmDeletePerson"
      title="Eliminar invitado"
      description="¿Está seguro que desea realizar dicha acción? Este proceso es irreversible y no podrá recuperar la información"
    />
    <VisitPersonEditModal
      v-model="modals.form"
      :visitPerson="visitPerson"
      @cancelled="onCancel"
      @created="addedPerson"
      @updated="editedPerson"
      :local="true"
    />
  </v-layout>
</template>

<script>
import desition from "../../Dialogs/Confirm";
import VisitPersonEditModal from "./VisitPersonEditModal";

export default {
  components: {
    desition,
    VisitPersonEditModal,
  },
  props: ["people"],
  data: () => ({
    modals: {
      confirmDeletePerson: false,
      form: false,
    },
    visitPerson: null,
    personToDeleted: "",
  }),
  methods: {
    removePerson(index) {
      this.personToDeleted = index;
      this.modals.confirmDeletePerson = true;
    },
    onDeletePerson() {
      this.people.externs.splice(this.personToDeleted, 1);
      this.personToDeleted = "";
    },
    onCancel() {
      this.modals.form = false;
      this.personToDeleted = "";
      this.visitPerson = null;
    },
    editPerson(visitPerson, index) {
      this.visitPerson = visitPerson;
      this.personToDeleted = index;
      this.modals.form = true;
    },
    editedPerson(_, el) {
      this.$emit("editedPerson", this.personToDeleted, {
        firstName: el.firstName,
        lastName: el.lastName,
        email: el.email,
        phone: el.phone,
      });
      this.onCancel();
    },
    addPerson() {
      this.modals.form = true;
    },
    addedPerson(_, el) {
      this.$emit("addedPerson", {
        firstName: el.firstName,
        lastName: el.lastName,
        email: el.email,
        phone: el.phone,
      });
      this.onCancel();
    },
  },
};
</script>

<style>
</style>
